import { styled } from '@mui/material/styles';
import { common } from 'src/theme/palette';

export const SelectedColor = styled('div')(() => ({
    position: 'absolute',
    left: '50px'
}));
export const ColorBoxStyle = styled('div')(() => ({
    width: '100%',
    height: 'auto',
    display: 'none',
    borderRadius: '50%',
    alignItems: 'center',
    justifyContent: 'center',
    marginRight: 0,
    position: 'relative',
    '& input': {
        width: 23,
        height: 23,
        border: 'none',
        outline: 'none',
        cursor: 'pointer',
        WebkitAppearance: 'none',
        backgroundColor: 'transparent',
        '&::-webkit-color-swatch-wrapper': { padding: 0 },
        '&::-moz-color-swatch': { border: 'none', borderRadius: '50%' },
        '&::-webkit-color-swatch': { border: 'none', borderRadius: '50%' },
    },
}));
export const tagsBoxStyle = (type) => ({
    width: '100%',
    height: type === 'table' ? '100%' : 'auto',
    padding: '0',
    maxWidth: '100%',
    marginLeft: '0',
    '@media (max-width: 900px)': {
        ml: '0',
        mb: type === 'table' ? '0' : '20px'
    }
});
export const tagsStyle = (type, isLight, tableType, length) => ({
    width: '100%',
    maxWidth: '100%',
    maxHeight: type === 'table' ? '100%' : '100%',
    overflow: type === 'table' ? 'hidden' : 'auto',
    minWidth: 0,
    border: type === 'leadDetail' ? 'none' : '2px solid transparent',
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: type === 'table' ? 'center' : 'flex-start',
    borderRadius: type === 'leadDetail' ? 1 : 0,
    p: 0,
    // eslint-disable-next-line no-nested-ternary
    pb: type === 'leadDetail' && length > 0 ? '4px' : (type === 'leadDetail' ? (length <= 0 ? '12px' : 0) : 0),
    '.MuiAutocomplete-input': {
        width: tableType === 'ArchiveTable' && '0px !important',
        minWidth: tableType === 'ArchiveTable' && '0 !important',
        pointerEvents: tableType === 'ArchiveTable' ? 'none' : 'visible',
        maxWidth: '100%',
    },
    '.MuiOutlinedInput-notchedOutline': {
        display: 'none'
    },
    '&.Mui-focused': {
        border: type === 'leadDetail' ? `1px solid ${common.black}` : '1px solid transparent',
        p: type === 'leadDetail' ? '12px 12px 12px' : 0,
        // eslint-disable-next-line no-nested-ternary
        pb: type === 'leadDetail' && length > 0 ? '4px' : (type === 'leadDetail' ? (length <= 0 ? '12px' : 0) : 0),
    },
    '&::-webkit-scrollbar': {
        width: '0.4em',
    },
    '&::-webkit-scrollbar-track': {
        boxShadow: 'inset 0 0 6px rgba(0,0,0,0.00)',
        webkitBoxShadow: 'inset 0 0 6px rgba(0,0,0,0.00)',
    },
    '&::-webkit-scrollbar-thumb': {
        backgroundColor: (isLight ? 'rgba(0,0,0,.1)' : 'rgba(255, 255, 255,.1)'),
        borderRadius: '10px',
    },
    '.MuiAutocomplete-endAdornment': {
        display: 'none'
    },
    '.MuiInputBase-input': {
        padding: '1px 0 !important',
        textAlign: 'center',
    },
    '.MuiInputBase-root': {
        padding: '0px !important',
    },
    '[placeholder="+"]::placeholder': {
        width: '18px',
        height: '18px',
        background: "url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='18' height='18' viewBox='0 0 24 24' fill='%23919EAB' fill-opacity='0.5'%3E%3Cpath d='M12 2a10 10 0 1 0 10 10A10 10 0 0 0 12 2zm5 11h-4v4h-2v-4H7v-2h4V7h2v4h4z'/%3E%3C/svg%3E\")",
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        backgroundSize: '18px',
        fontSize: '0',
        position: 'absolute',
        verticalAlign: 'middle',
        textAlign: 'center',
        top: '50%',
        transform: 'translateY(-50%)',
        left: 0,
        right: 0,
        margin: '0 auto'
    },
    '&.Mui-focused [placeholder="+"]::placeholder': {
        background: 'none'
    },
    '&.Mui-focused [placeholder="+"]::-moz-placeholder': {
        background: 'none'
    },
    '.MuiSvgIcon-root': {
        display: (tableType === 'ArchiveTable' && 'none !important'),
    }
});

export const selectedTagStyle = () => ({
    padding: '8px',
    width: '100%'
});

export const allTagChipStyle = {
    '.MuiChip-root': {
        bgcolor: 'rgba(24, 144, 255, 0.16)',
        color: 'widget.tagBlueColor',
        height: '22px',
        borderRadius: '6px',
        fontSize: '0.75rem',
        fontWeight: 500,
        margin: '0 3px'
    },
    '.MuiChip-root:hover': {
        bgcolor: 'rgba(24, 144, 255, 0.16)',
    },
    '.MuiChip-root svg': {
        color: 'widget.tagBlueColor'
    },
    '.MuiChip-root .MuiChip-label': {
        px: '8px'
    }
};

// searchbar

export const InputTags = (colour) => ({
    margin: '1px 2px',
    padding: '0',
    height: '22px',
    fontSize: '11px',
    ...(colour && {
        bgcolor: `${colour}22`,
        color: colour,
        border: `1px solid ${colour}44`,
    }),
    ' .MuiChip-label': {
        padding: '0 6px',
        fontSize: '12px',
        lineHeight: 1.4,
    },
    ' .MuiSvgIcon-root': {
        fontSize: '14px',
        ...(colour && { color: `${colour} !important` }),
    },
    '.MuiChip-deleteIcon': {
        ...(colour && { color: `${colour}88 !important` }),
        '&:hover': {
            ...(colour && { color: `${colour} !important` }),
        },
    },
});

export const leadDetailsChipStyle = {
    margin: '0 8px 8px 0',
    padding: '4px',
    height: 'auto',
    fontSize: '11px',
    bgcolor: 'common.lightGrey',
    color: 'common.slateGray',
    ' .MuiChip-label': {
        padding: '0.5px 8px',
        fontSize: '13px'
    },
    ' .MuiSvgIcon-root': {
        fontSize: '16px',
    }
};

export const searchTagsStyle = (isLight) => ({
    width: '100%',
    borderRadius: '8px',
    maxWidth: '100%',
    maxHeight: '72px',
    minWidth: '120px',
    '@media (max-width: 600px)': {
        minWidth: '90px',
    },
    '&::-webkit-scrollbar': {
        width: '0.4em',
    },
    '&::-webkit-scrollbar-track': {
        boxShadow: 'inset 0 0 6px rgba(0,0,0,0.00)',
        webkitBoxShadow: 'inset 0 0 6px rgba(0,0,0,0.00)',
    },
    '&::-webkit-scrollbar-thumb': {
        backgroundColor: (isLight ? 'rgba(0,0,0,.1)' : 'rgba(255, 255, 255,.1)'),
        borderRadius: '10px',
    },
    '& .MuiOutlinedInput-root': {
        borderRadius: '8px',
        '& fieldset': { borderColor: 'rgba(145, 158, 171, 0.32)' },
        '&:hover fieldset': { borderColor: 'rgba(145, 158, 171, 0.6)' },
        '&.Mui-focused fieldset': { borderColor: 'primary.main', borderWidth: '1.5px' },
    },
});